'use client'
import {
  useConfig_default
} from "./chunk-UDUUTZIS.mjs";

// src/hooks/useShowContactUs.ts
var useShowContactUs = () => {
  const { showContactUs } = useConfig_default();
  return {
    showContactUs
  };
};

export {
  useShowContactUs
};
//# sourceMappingURL=chunk-RQWA4U3V.mjs.map